/**
 * Mapeos y funciones puras para el flujo de emisión.
 * Sin dependencias de Vue ni servicios.
 */

import type { EmissionQuoteContext } from "@/types/emission.types";

const FORMA_PAGO_MAP: Record<string, string> = {
  Contado: "C",
  Mensual: "M",
  Semestral: "S",
  Trimestral: "T",
};

const PAQUETE_MAP: Record<string, string> = {
  Amplia: "1",
  Limitada: "3",
  Plus: "2",
  "Responsabilidad Civil": "4",
};

const CIA_NAMES: Record<number, string> = {
  2: "Qualitas",
  3: "ANA",
};

export function mapFormaPago(formaPago: string): string {
  return FORMA_PAGO_MAP[formaPago] ?? "C";
}

export function mapPaquete(planType: string): string {
  return PAQUETE_MAP[planType] ?? "1";
}

export function getNombreCia(idCia: number | undefined): string {
  return CIA_NAMES[idCia ?? 0] ?? "";
}

export function mapIdCia(
  companyName: string | null | undefined,
): number | undefined {
  if (!companyName) return undefined;
  const name = companyName.toUpperCase();
  if (name.includes("QUALITAS")) return 2;
  if (name.includes("ANA")) return 3;
  return undefined;
}

export function calcularEdad(
  fechaNacimiento: string | null | undefined,
): number {
  if (!fechaNacimiento) return 0;
  const fecha = new Date(fechaNacimiento);
  const hoy = new Date();
  let edad = hoy.getFullYear() - fecha.getFullYear();
  const mes = hoy.getMonth() - fecha.getMonth();
  if (mes < 0 || (mes === 0 && hoy.getDate() < fecha.getDate())) edad--;
  return edad;
}

export function getIdSexo(gender: string | null | undefined): number {
  if (gender === "M") return 1;
  if (gender === "F") return 2;
  return 0;
}

export function splitFullName(fullName: string): {
  nombres: string;
  paterno: string;
  materno: string;
} {
  if (!fullName?.trim()) return { nombres: "", paterno: "", materno: "" };
  const parts = fullName.trim().split(/\s+/);
  if (parts.length === 1)
    return { nombres: parts[0], paterno: "", materno: "" };
  if (parts.length === 2)
    return { nombres: parts[0], paterno: parts[1], materno: "" };
  const nombres = parts.slice(0, -2).join(" ");
  const paterno = parts[parts.length - 2];
  const materno = parts[parts.length - 1];
  return { nombres, paterno, materno };
}

export function buildConcepto(quote: EmissionQuoteContext): string {
  const year = quote.year ? String(quote.year) : "";
  const brand = quote.brand?.name ?? "";
  const type = quote.type ?? "";
  const modelDescription = quote.model?.name ?? "";
  const parts: string[] = [];
  if (brand) parts.push(brand.toUpperCase());
  if (type) parts.push(type);
  if (modelDescription) parts.push(modelDescription);
  if (year) parts.push(year);
  return parts.join(" ") || "Vehículo";
}
